import {Input} from "antd";
import styles from "./Language.module.scss"
import cl from "classnames";
import {useLang} from "../../../hooks";
import {LANG_KEY} from "../../../constants";

export const LanguageSwitch = () => {
  const {lang, handleChangeLang} = useLang()
  const handleChangeLangInput = (val: boolean) => {
    if (val) {
      handleChangeLang(LANG_KEY.RU)
    } else {
      handleChangeLang(LANG_KEY.KZ)
    }
  }

  return (
    <div className={styles.language}>
      <Input id="language-toggle" className={cl(styles.checkToggle, styles.checkToggleRoundFlat)} type="checkbox"
             checked={lang !== LANG_KEY.KZ} onChange={(e) => handleChangeLangInput(e.target.checked)}/>
      <label htmlFor="language-toggle">
        <span className={cl(styles.on)}>KZ</span>
        <span className={cl(styles.off)}>RU</span>
      </label>
    </div>
  )
}